import React, { useEffect, useState } from 'react';

import { storeNationalId } from '@tb-core/helpers/next-env';
import sessionStorage from '@tb-core/helpers/session-storage';
import { getQueryStoreId } from '@tb-core/helpers/store';
import getUser from '@tb-core/providers/get-user';
import { JsxChildren, User } from '@tb-core/types';

interface UserProviderProps {
    children: JsxChildren;
    // This will indicate if we need to fetch the user data
    enabled?: boolean;
}

const UserContext = React.createContext<Partial<User>>({});
const { Consumer, Provider } = UserContext;

const UserProvider = ({ children, enabled = true }: UserProviderProps) => {
    const [user, setUser] = useState<Partial<User>>({});
    const fetchUser = async () => {
        const { currentStore } = sessionStorage.getItems();
        const queryStoreId = getQueryStoreId(window.location.search);
        const updateUser = (user: User) => {
            // Update logged in status
            user.isLoggedIn = user.userUid ? true : false;
            sessionStorage.setItems({ user });
            setUser(user);
        };

        // Sync user store with latest store id either from querystring or hybris currentStore
        // Known issue that currentStore is only set by Hybris so we may run into inconsistent store id values
        // @TODO This should be fixed by CXO locations
        updateUser(
            await getUser(
                queryStoreId || (currentStore && String(currentStore))
            )
        );
    };

    useEffect(() => {
        if (enabled) {
            fetchUser();
        }
    }, []);

    return <Provider value={user}>{children}</Provider>;
};

const UserConsumer = Consumer;

export default UserProvider;
export { UserConsumer, UserContext };
